import React from "react";
import {PaymentMethod} from "../../../model/PaymentMethod";
import {PrePayCreditCardInstructions} from "./credit-card/PrePayCreditCardInstructions";
import {PrePayAchInstructions} from "./ach/PrePayAchInstructions";
import {LoanData} from "../../../../loan-details/model/LoanData";
import {PrePayCreditCardCreditReportInstructions} from "./credit-card/PrePayCreditCardCreditReportInstructions";
import {FeeOptionKey} from "../../../../loan-details/component/FeeSelector";

interface Props {
    method: PaymentMethod;
    address: string;
    loan: LoanData;
    selectedFees?: FeeOptionKey[];
}

export class PrePayInstructionsMethodSwitch extends React.Component<Props> {

    render() {
        switch (this.props.method) {
            case PaymentMethod.CREDIT_CARD: {
                const isAppraisalFeeEnabled = this.props.loan.appraisalFeeEnabled;
                const isCreditCardEnabled = this.props.loan.creditCardEnabled;
                if(isCreditCardEnabled) return <PrePayCreditCardCreditReportInstructions loan={this.props.loan}
                                                                             address={this.props.address}/>

                return <PrePayCreditCardInstructions loan={this.props.loan}
                                                     address={this.props.address}
                                                     selectedFees={this.props.selectedFees}/>
            }
            case PaymentMethod.ACH: {
                return <PrePayAchInstructions loan={this.props.loan}
                                              address={this.props.address}/>;
            }
        }
    }

}
